import { requestWithToken } from 'app/utils/request';
import { URL_API_SMARTAPPS } from 'app/utils/urlConstants';

export async function getLaunchableSmartAppsApi() {
  const requestURL = `${URL_API_SMARTAPPS}/launchable`;

  const launchableSmartApps = await requestWithToken(requestURL);
  return launchableSmartApps;
}
